import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBQS010InitRequest } from 'types/MCBQS010/MCBQS010InitRequest'
import { MCBQS010DowloadFlieRequest } from 'types/MCBQS010/MCBQS010DowloadFlieRequest'

  // 前画面から渡された情報、画面データ（Redux-Store）に格納する
  export interface initRequestInofoRow  { 
  jobSeekerByCompanyId: string //企業別求職者ID
  jobSeekerId: string //求職者ID 

  }

// ファイル一覧表示用
export interface FileListDisplayInfoRow  {
  fileNo:number//項番
  checked: boolean//選択
  fileName: string //ファイル名
  fileCategory: string //分類
  outputFileFlag: string //出力ファイルフラグ
  id: string //id
  filePath: string //ファイルパス
  fileSubmissionDisplayOrder:number//ファイル提出物表示順
}

// MCB提出内容情報：エントリーシート、履歴書、オリジナル設問、研究概要書
export interface McbSubmissionRequestInfoRow  {
  jobSeekerId : number;// 求職者ID
  jobSeekerByCompanyId: number;// 企業別求職者ID
  submissionRequestId:number,//提出リクエストID
  submissionEntrySheetPdfFullpath: string //提出物エントリシートPDF格納パス
  submissionResumePdfFullpath : string//提出物履歴書PDF格納パス
  submissionResearchSummaryPdfFullpath: string,//提出物研究概要書PDF格納パス
  submissionOriginalQuestionPdfFullpath : string,//提出物オリジナル設問PDF格納パス
  mcbSubmissionRequestId:number,//MCB提出リクエストID
  mycareercd: string,//mycareercd
  submissionContentId:number,//提出物内容ID
  submissionContentName: string,//提出物内容名
  submissionEntrySheetFlag: string,//提出物エントリシートフラグ
  submissionResumeFlag: string,//提出物履歴書フラグ
  submissionResearchSummaryFlag: string,//提出物研究概要書フラグ
  submissionOriginalQuestionFlag: string,//提出物オリジナル設問フラグ
  submissionFileSubmissionFlag: string,//提出物ファイル提出フラグ
}

// 選考ファイル情報
export interface SelectionFileInfoRow  {
  selectionFileName : string,//	選考ファイル名
  displayOrder : string,//	表示順
  jobSeekerSelectionFileId:number,//	求職者・選考ファイルID
  selectionFileManagementId:number,//	選考ファイル管理ID
  selectionFileKey : string,//	選考ファイルキー
}

// 初期表示画面表示情報
export interface MCBQS010InitInfo {
  fileListDisplayInfo: FileListDisplayInfoRow[], //ファイル一覧表示用
  mcbSubmissionRequestInfo:McbSubmissionRequestInfoRow[],//MCB提出内容情報：エントリーシート、履歴書、オリジナル設問、研究概要書
  selectionFileInfo:SelectionFileInfoRow[],//選考ファイル情報
  selectedSelectionFileCountLimit:string,//個別選考ファイル選択件数上限値
}

//　画面で選択された情報
// 選択されたファイル一覧表示情報
export interface SelectedFileListDisplayInfoDto  {
  fileNo:number//項番
  outputFileFlag: string //出力ファイルフラグ
  id: string //id
  filePath: string //ファイルパス
  fileSubmissionDisplayOrder:number//ファイル提出物表示順
}

// 選択されたMCB提出内容情報
export interface SelectedMcbSubmissionRequestInfoDto  {
  jobSeekerId : number
  jobSeekerByCompanyId: number
  submissionRequestId: number //提出リクエストID
  mcbSubmissionRequestId: number //MCB提出リクエストID
  mycareercd: string 	//mycareercd
  submissionContentId: number 	//提出物内容ID
}

// 選択された選考ファイル情報
export interface SelectedSelectionFileInfoDto  {
 selectionFileManagementId: number //選考ファイル管理ID
 jobSeekerSelectionFileId: number //求職者・選考ファイルID
}

// 初期State
const initialState: {
  fileListDisplayInfo:FileListDisplayInfoRow[] //ファイル一覧表示用
  mcbSubmissionRequestInfo:McbSubmissionRequestInfoRow[],
  selectionFileInfo:SelectionFileInfoRow[],//選考ファイル情報
  selectedSelectionFileCountLimit:string,
  dialogOpen: boolean,
  initRequestInof:initRequestInofoRow
} = {
  fileListDisplayInfo: [],
  mcbSubmissionRequestInfo:[],
  selectionFileInfo:[],
  selectedSelectionFileCountLimit:'',
  dialogOpen: false,
  initRequestInof:{jobSeekerByCompanyId:'',jobSeekerId:''},
}


const  outputFileSelect = createSlice({
    name: 'outputFileSelect',
    initialState,
    reducers: {
      //MCBQS010 初期表示時
      mcbqs010InitInfo(state,action:PayloadAction<MCBQS010InitRequest>) {
        //企業別求職者ID
        state.initRequestInof.jobSeekerByCompanyId = action.payload.jobSeekerByCompanyId
        //求職者ID
        state.initRequestInof.jobSeekerId = action.payload.jobSeekerId
        return state
      },
      // 初期表示時
      setMCBQS010InitInfo(state, action:PayloadAction<MCBQS010InitInfo>) {
        //console.log('1111payload-----', JSON.stringify(action.payload));
        state.fileListDisplayInfo=action.payload.fileListDisplayInfo
        state.mcbSubmissionRequestInfo=action.payload.mcbSubmissionRequestInfo
        state.selectionFileInfo=action.payload.selectionFileInfo
        state.selectedSelectionFileCountLimit=action.payload.selectedSelectionFileCountLimit

        return state;
      },

      // Dialog表示
      setDialogOpen(state, action: PayloadAction<boolean>) {
            state.dialogOpen = action.payload
            return state
        },

      //「出力する」ボタン押下処理
      mcbqs010DowloadFlie(state, action: PayloadAction<MCBQS010DowloadFlieRequest>){
        return state
      },

      setProps(state,action: PayloadAction<any>){
        state={...state,...action.payload}
        return state
      },
    
    }
  })
export const {
    mcbqs010InitInfo,
    setMCBQS010InitInfo,
    setProps,
    setDialogOpen,
    mcbqs010DowloadFlie,
    
} = outputFileSelect.actions

export default outputFileSelect.reducer